import React from 'react';
import { ModalBase } from './ModalBase';
import { Button } from './Button';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ThankYouModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onClose}
      title="¡Enviado con Éxito!"
      containerClassName="max-w-md"
      headerClassName="bg-green-50 border-green-200"
      titleClassName="text-green-800"
    >
      <div className="text-center p-4">
        <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
            <svg className="h-12 w-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
        </div>
        <h3 className="text-2xl font-bold text-gray-800 mb-2">¡Gracias por contactarnos!</h3>
        <p className="text-gray-600">
          Hemos recibido tu consulta correctamente. Nuestro equipo la revisará y se pondrá en contacto contigo a la brevedad posible.
        </p>
        <div className="mt-8">
            <Button onClick={onClose} variant="success" size="large">
                Entendido
            </Button>
        </div>
      </div>
    </ModalBase>
  );
};
